export const USER_INIT = {
  username: '',
  firstName: '',
  lastName: '',
  phone: '',
  subdivision: null,
  branchCode: null,
  position: '',
  photo: '',
  birthDate: null,
  iin: '',
  male: null,
  email: '',
  roles: [],
  password: '',
  isSystemUser: null,
  mainUser: true,
  creditProducts: []
}

export const FILTER_INIT = {
  username: '',
  userFullname: '',
  roleCode: null,
  subdivision: null,
  projectCode: null,
  branchCode: null,
  isActive: 'all',
  isSystemUser: null
}

export const NEW_ROLE_INIT = {
  selectedRole: null,
  selectedProject: null,
  selectedBranches: []
}
